import { IIdentityPool } from '~src/authentication/serverApi/types/identityPools/IIdentityPool';
import { CreateUserIdentityService } from '~src/authentication/services/CreateUserIdentityService';
import { Messages } from '~src/codegen/Localize';
import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { ServerSettingsUnauthenticated } from '~src/settings/services/ServerSettingsUnauthenticated';
import { IUser } from '~src/userManagement/users/serverApi/types/IUser';

import { CreateActiveDirectoryUserIdentityDialogBody, CreateActiveDirectoryUserIdentityDialogBodyProps, CreateActiveDirectoryUserIdentityDialogState } from './CreateActiveDirectoryUserIdentityDialog';

export function showCreateActiveDirectoryUserIdentityDialog(identityPool: IIdentityPool, user: IUser, isServerUser: boolean): Promise<any> {
  const isLdapStore = ServerSettingsUnauthenticated.isLdapStore();
  const modalInstance = openReactActionDialog<CreateActiveDirectoryUserIdentityDialogBodyProps, CreateActiveDirectoryUserIdentityDialogState, any>({
      title: Messages.identityPools_AddToPoolAction_DialogTitle(),
      bodyComponent: CreateActiveDirectoryUserIdentityDialogBody,
      initialBodyProps: {
        prompt: Messages.identityPools_CreateActiveDirectoryIdentityAction_DialogDescription({
          USER_DISPLAY_NAME: user.displayName,
          IDENTITY_POOL_NAME: identityPool.name,
          DIRECTORY_NAME: isLdapStore ? 'LDAP': 'Active Directory'}),
        identityPool: identityPool,
        user: user,
        isServerUser: isServerUser
      },
      initialDialogState: { username: undefined },
      actionName: Messages.save(),
      dismissDialogOnActionFailed: true,
      action: (props: CreateActiveDirectoryUserIdentityDialogBodyProps, dialogState: CreateActiveDirectoryUserIdentityDialogState) => {
        if (modalInstance) {
          modalInstance.close();
        }

        const poolName = props.identityPool?.id === 'DEFAULT' ? null : props.identityPool?.name;
        return CreateUserIdentityService.createActiveDirectoryIdentityForUser(props.user, poolName, dialogState.username, props.isServerUser);
      },
      actionDisabled: (props: CreateActiveDirectoryUserIdentityDialogBodyProps, dialogState: CreateActiveDirectoryUserIdentityDialogState) => dialogState.username === undefined,
      dialogWidth: TabDialogWidth.width500px,
  });

  return modalInstance.result;
}
